export const CustomerDetailsListStyles = {
  container: {
    padding: "25px 30px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    maxWidth: "1920px",
    margin: "0 auto",
    marginTop: "68px",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  buttonsContainer: {
    display: "flex",
    gap: "20px",
    alignItems: "center",
  },
  button: {
    padding: "9px 24px",
    boxShadow: "none",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
      color: "var(--support-white)",
    },
  },
  addTaskButton: {
    padding: "9px 32px",
    boxShadow: "none",
  },
  drawer: {
    width: "820px",
    padding: "0px",
  },
  tabsText: {
    fontFamily: "var(--font-playfair-display)",
    fontSize: "var(--font-size-20)",
    fontWeight: "var(--font-weight-400)",
  },
  tabs: {
    marginTop: "5px",
  },
  menuIcon: {
    cursor: "pointer",
    "> img": {
      marginRight: "10px",
    },
  },
  // Modal Styles
  modalContainer: {
    bgcolor: "#fff",
    borderRadius: "8px",
    boxShadow: "0px 4px 24px rgba(0, 0, 0, 0.10)",
    width: "calc(100% - 32px)",
    maxWidth: "560px",
    padding: "24px",
    display: "flex",
    height: "230px",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
  },
  modalHeading: {
    fontWeight: 600,
    fontSize: "18px",
    color: "#181C32",
    marginBottom: "16px",
    marginTop: 0,
    textAlign: "left",
    fontFamily: "var(--font-noto-sans)",
    background: "none",
    padding: 0,
  },
  modalHeadingContainer: {
    marginBottom: "16px",
    marginTop: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    position: "relative",
    margin: "0px 0px",
  },
  modalContent: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  modalButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "8px",
  },
  modalCancelButton: {
    border: "1px solid #CED4DA",
    borderRadius: "4px",
    padding: "8px 16px",
    fontWeight: 500,
    fontSize: "14px",
    color: "#495057",
    bgcolor: "#fff",
    boxShadow: "none",
  },
  modalProceedButton: {
    borderRadius: "4px",
    padding: "8px 16px",
    fontWeight: 500,
    fontSize: "14px",
    color: "#fff",
    backgroundColor: "#007bff",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#0056b3",
    },
  },
  modalDropdown: {
    bgcolor: "#fff",
    borderRadius: "4px",
    border: "2px solid #181C32",
    boxShadow: "none",
    padding: "8px 12px",
    fontSize: "14px",
    fontWeight: 400,
    color: "#495057",
    minWidth: 0,
    width: "100%",
    height: "60px",
    marginBottom: "24px",
    marginTop: 0,
  },
  modalDropdownSelect: {
    bgcolor: "#fff",
    borderRadius: "4px",
    border: "none",
    boxShadow: "none",
    padding: "8px 12px",
    fontSize: "14px",
    fontWeight: 400,
    color: "#495057",
    minWidth: 0,
    width: "30rem",
    display: "flex",
    alignItems: "center",
  },
  modalDropdownMenuItem: {
    bgcolor: "#fff",
    boxShadow: "none",
    padding: "8px 12px",
    fontSize: "14px",
    fontWeight: 400,
    color: "#495057",
    "&:hover": {
      bgcolor: "#F8F9FA",
    },
  },
};
